import type { CookieParseOptionsForNookies, Cookies } from './types';

export const defaultOptions: CookieParseOptionsForNookies = {
  decode: (value: string) => value,
};

const findCookieName = (
  cookies: Cookies,
  filterCallback: (key: string) => boolean
) => {
  const cookieNames = Object.keys(cookies);
  const foundCookieNames = cookieNames.filter((key) => filterCallback(key));

  return foundCookieNames.length === 0 ? null : foundCookieNames[0];
};

export const getCookieNameByPrefix = (
  cookies: Cookies,
  cookieNamePrefix: string
) => findCookieName(cookies, (key) => key.startsWith(cookieNamePrefix));

export const getCookieNameByPrefixAndSuffix = (
  cookies: Cookies,
  cookieNamePrefix: string,
  cookieNameSuffix: string
) =>
  findCookieName(
    cookies,
    (key) => key.startsWith(cookieNamePrefix) && key.endsWith(cookieNameSuffix)
  );
